import api from './api'
import type { Service, ServiceFeature } from '@/types'

export const servicesService = {
  // Get all services
  getServices: async (params?: {
    is_active?: boolean
    search?: string
    ordering?: string
  }): Promise<Service[]> => {
    const response = await api.get('/services/', { params })
    return response.data.results || response.data
  },

  // Get service by ID
  getService: async (id: number): Promise<Service> => {
    const response = await api.get(`/services/${id}/`)
    return response.data
  },

  // Get service features
  getServiceFeatures: async (): Promise<ServiceFeature[]> => {
    const response = await api.get('/services/features/')
    return response.data.results || response.data
  },
}
